/**
 * Custom dropdown filters with Facet Checkboxes
 */

const getProximityFacetName = (group) => group.closest('.facetwp-facet')?.dataset.name;

const getProximityRadius = (group) => {
	const facetName = getProximityFacetName(group);
	const selectedValues = facetName ? FWP.facets?.[facetName] : null;
	const radiusInput = group.querySelector('.facetwp-radius');

	if (selectedValues?.length) {
		return selectedValues[2];
	}

	return radiusInput?.value;
};

const setProximityLabel = (group, selectLabel) => {
	const radius = getProximityRadius(group);

	if (radius) {
		selectLabel.innerHTML = '+' + radius + ' km';
	} else {
		selectLabel.innerHTML = selectLabel.dataset.placeholder;
	}
};

// Single capture-phase handler: runs before FacetWP / other bubble handlers so toggles always apply.
function strlHandleFilterDropdownDocumentClick(event) {
	const resetButton = event.target.closest('[data-reset-filter]');
	if (resetButton && resetButton.dataset.resetFilter) {
		if (typeof FWP !== 'undefined') {
			FWP.reset(resetButton.dataset.resetFilter);
		}
		event.preventDefault();
		return;
	}

	const filterTitle = event.target.closest('[data-filter-group-title]');
	const filterWrap = filterTitle ? filterTitle.closest('[data-filter-dropdown]') : null;
	if (filterWrap) {
		document.querySelectorAll('[data-filter-dropdown]').forEach((dropdown) => {
			if (dropdown !== filterWrap) {
				dropdown.classList.remove('open');
			}
		});
		filterWrap.classList.toggle('open');
		event.preventDefault();
		return;
	}

	document.querySelectorAll('[data-filter-dropdown]').forEach((dropdown) => {
		if (!dropdown.contains(event.target)) {
			dropdown.classList.remove('open');
		}
	});
}

document.addEventListener('click', strlHandleFilterDropdownDocumentClick, true);

// Show selected value(s) in placeholder
document.addEventListener('facetwp-loaded', () => {
	const overviewVacancy = document.querySelector('[data-prefilter-expertise]');
	const expertisePrefilter = overviewVacancy?.dataset.prefilterExpertise
		? overviewVacancy.dataset.prefilterExpertise.split(',').filter(Boolean)
		: [];
	const selectedExpertise = FWP.facets?.expertise || [];

	if (
		expertisePrefilter.length &&
		!selectedExpertise.length &&
		!window.strlExpertisePrefilterApplied
	) {
		window.strlExpertisePrefilterApplied = true;
		FWP.facets.expertise = expertisePrefilter;
		FWP.parseFacets();
		FWP.setHash();
		FWP.refresh();
		return;
	}

	const filterDropdownGroups = document.querySelectorAll('[data-filter-dropdown]');
	filterDropdownGroups.forEach((group) => {
		const selectLabel = group.querySelector('[data-filter-group-title]>span');
		const filterName = group.dataset.filterName;

		if (!selectLabel) {
			return;
		}

		if ('proximity' === filterName) {
			setProximityLabel(group, selectLabel);

			const radiusInput = group.querySelector('.facetwp-radius');
			if (radiusInput && !radiusInput.dataset.labelBound) {
				const updateLabel = () => setProximityLabel(group, selectLabel);
				radiusInput.addEventListener('input', updateLabel);
				radiusInput.addEventListener('change', updateLabel);
				radiusInput.dataset.labelBound = 'true';
			}
		} else {
			const facet = document.querySelector('[data-name="' + filterName + '"]');
			const selectedValues = FWP.facets[filterName];

			if (selectedValues?.length) {
				let selectedLabels = [];
				selectedValues.forEach((value) => {
					selectedLabels.push(
						facet.querySelector('[data-value="' + value + '"] .facetwp-display-value')?.innerText
					);
				});
				selectLabel.innerHTML = selectedLabels.join(', ');
			} else {
				selectLabel.innerHTML = selectLabel.dataset.placeholder;
			}
		}
	});
});

// Close dropdowns on choice
document.addEventListener('facetwp-refresh', () => {
	const filterDropdowns = document.querySelectorAll('[data-filter-dropdown]');

	filterDropdowns.forEach((dropdown) => {
		// Logic: Only close if it's NOT a proximity facet,
		// or add a check to see if the user is still typing/selecting.
		if (dropdown.dataset.filterName !== 'proximity') {
			dropdown.classList.remove('open');
		}
	});
});

